import type { ReactNode } from 'react';

export function Field({ label, hint, error, children }: { label: string; hint?: string; error?: string; children: ReactNode }) {
  return (
    <label className="flex flex-col gap-2">
      <span className="field-label">{label}</span>
      {children}
      {hint ? <span className="hint">{hint}</span> : null}
      {error ? <span className="text-[0.8rem] text-status-error dark:text-red-400">{error}</span> : null}
    </label>
  );
}
